<template>
  <div class="box">
    <div class="name">{{ name }}</div>
    <div class="value">
      {{ value }}
      <span class="value-unit">{{ unit }}</span>
    </div>
    <div class="total" id="total-reg" ref="total"></div>
  </div>
</template>

<script>
export default {
  name: "dataItem",
  props: {
    name: {
      type: String,
      default: () => "数据名称",
    },
    unit: {
      type: String,
      default: () => "m/s",
    },
    total: {
      type: Number,
      default: () => 24,
    },
    value: {
      type: Number,
      default: () => 18,
    },
    color: {
      type: String,
      default: () => "#0F3D61",
    },
    startColor: {
      type: Array,
      default: () => [16, 139, 247],
    },
    endColor: {
      type: Array,
      default: () => [15, 218, 250],
    },
    diff: {
      type: Number,
      default: () => 2,
    },
    abs: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      startColor1: [],
      endColor1: [],
    };
  },
  mounted() {
    let that = this;
    this.initStatus(20);
  },
  updated() {
    // document.getElementById('total-reg').innerHTML = ''
    this.updateStatus(20);
  },
  watch: {
    startColor(n, o) {
      // console.log("startColor", n, o);
      this.updateStatus(20);
    },
    endColor(n, o) {},
  },
  methods: {
    initStatus(cubeCount) {
      let val = this.value;
      if (this.abs) {
        val = Math.abs(val);
      }
      let tot = this.total;
      if (tot < val) {
        tot = val;
      }
      let ratio = val / tot;
      // let totalDomWidth = this.$refs.total.offsetWidth;
      // let cubeWidth =
      //   ((Math.floor(totalDomWidth / cubeCount - 1) - this.diff) / 1920) * 100;
      // let totalDomWidth = this.$refs.total.offsetWidth;
      // let cubeWidth =
      //   ((Math.floor(totalDomWidth / cubeCount - 1) - this.diff) / 1920) * 100;
      let cubeWidth = 70 / cubeCount;
      let cubeDomArr;
      for (let i = 0; i < cubeCount; i++) {
        let cubeDom = document.createElement("span");

        cubeDom.style.background = this.color;
        cubeDom.style.width = cubeWidth + "%";
        cubeDom.style.borderRadius = ".3vh";
        this.$refs.total.appendChild(cubeDom);
      }

      let nowCubeCount = Math.floor(cubeCount * ratio);
      cubeDomArr = this.$refs.total.children;

      let startColor = this.startColor;
      let endColor = this.endColor;
      let perDiffColor = [];

      for (let i = 0; i < endColor.length; i++) {
        perDiffColor.push(
          Number(((endColor[i] - startColor[i]) / nowCubeCount).toFixed(3))
        );
      }
      let per = 1 / nowCubeCount;
      for (let i = 0; i < nowCubeCount; i++) {
        cubeDomArr[i].style.background = `RGB(
              ${startColor[0] + i * perDiffColor[0]},
              ${startColor[1] + i * perDiffColor[1]},
              ${startColor[2] + i * perDiffColor[2]})
            `;
        cubeDomArr[i].style.opacity = per * (i + 1);
        cubeDomArr[i].style.boxShadow =
          "0 .1vh 1vh 0 " +
          `RGB(
            ${endColor[0]},
            ${endColor[1]},
            ${endColor[2]}
          )`;
      }
    },
    updateStatus(cubeCount) {
      let val = this.value;
      if (this.abs) {
        val = Math.abs(val);
      }
      let tot = this.total;
      if (tot < val) {
        tot = val;
      }
      let ratio = val / tot;
      let nowCubeCount = Math.floor(cubeCount * ratio);
      let cubeDomArr = this.$refs.total.children;
      // let totalDomWidth = this.$refs.total.offsetWidth;
      // let cubeWidth =
      //   ((Math.floor(totalDomWidth / cubeCount - 1) - this.diff) / 1920) * 100;
      let cubeWidth = 70 / cubeCount;
      let startColor = this.startColor;
      let endColor = this.endColor;
      // let perDiffColor = [];
      for (let i = 0; i < cubeDomArr.length; i++) {
        let cubeDom = cubeDomArr[i];
        cubeDom.style = "";
        cubeDom.style.background = this.color;
        cubeDom.style.width = cubeWidth + "%";
        cubeDom.style.borderRadius = ".3vh";
      }
      // for (let i = 0; i < endColor.length; i++) {
      //   perDiffColor.push(
      //     Number(((endColor[i] - startColor[i]) / nowCubeCount).toFixed(3))
      //   );
      // }
      // console.log(perDiffColor);
      let per = 1 / nowCubeCount;
      for (let i = 0; i < nowCubeCount; i++) {
        // cubeDomArr[i].style.background = `RGB(
        //       ${startColor[0] + i * perDiffColor[0]},
        //       ${startColor[1] + i * perDiffColor[1]},
        //       ${startColor[2] + i * perDiffColor[2]})
        //     `;
        cubeDomArr[i].style.background = `RGB(
          ${startColor[0]},
          ${startColor[1]},
          ${startColor[2]}
        )`;
        cubeDomArr[i].style.opacity = per * (i + 1);
        cubeDomArr[i].style.boxShadow =
          "0 .1vh 1vh 0 " +
          `RGB(
            ${endColor[0]},
            ${endColor[1]},
            ${endColor[2]}
          )`;
      }
    },
  },
};
</script>


<style scoped>
.box {
  width: 100%;
  font-size: 0.938rem;
  height: 5vh;
  position: relative;
  color: #fff;
}
.box .name {
  position: absolute;
  font-size: 0.938rem;
  left: 0;
  top: 0;
}
.box .total {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.5vh;
  display: flex;
  justify-content: space-between;
}
.total {
  top: 3vh;
  display: flex;
  justify-content: space-around;
}
.box .value {
  position: absolute;
  color: #fff;
  font-size: 0.938rem;
  right: 0;
  top: 0;
}

.box .value span {
  font-size: 0.938rem;
}

.value-unit {
  font-size: 0.625rem;
  color: #bbb;
}

.name {
  color: #bbb;
}
</style>